import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUser = (state: IGlobalReduxStore) => state.auth.user;

export const isUserApprovedSelector = createSelector(
  getUser,
  (user) => user?.access_status === 'approved',
);
